/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import * as Faults from '../api/Faults'
import * as Airtime from '../api/Airtime'
import {
    FAULT_SORT,
    FAULT_STATES,
    LOG_ACTION_TYPES,
    LOG_OBJECT_TYPES,
    SYMPTOM_STATES,
    SYMPTOM_TYPES
} from "./common/FaultsConst";
import {showNotification} from "../common/ToastNotification";

export const SET_ASSET_FAULT = 'SET_ASSET_FAULT';
export const REQUEST_OBSERVATIONS = 'REQUEST_OBSERVATIONS';
export const RECEIVE_OBSERVATIONS = 'RECEIVE_OBSERVATIONS';
export const SET_OBSERVATION = 'SET_OBSERVATION';
export const REQUEST_SUBMIT_OBSERVATIONS = 'REQUEST_SUBMIT_OBSERVATIONS';
export const RECEIVE_SUBMIT_OBSERVATIONS = 'RECEIVE_SUBMIT_OBSERVATIONS';
export const REQUEST_ACTIONS = 'REQUEST_ACTIONS';
export const RECEIVE_ACTIONS = 'RECEIVE_ACTIONS';
export const REQUEST_SUBMIT_TEST_RESULT = 'REQUEST_SUBMIT_TEST_RESULT';
export const RECEIVE_SUBMIT_TEST_RESULT = 'RECEIVE_SUBMIT_TEST_RESULT';
export const REQUEST_SUBMIT_CORRECTIVE_ACTION_RESULT = 'REQUEST_SUBMIT_CORRECTIVE_ACTION_RESULT';
export const RECEIVE_SUBMIT_CORRECTIVE_ACTION_RESULT = 'RECEIVE_SUBMIT_CORRECTIVE_ACTION_RESULT';
export const REQUEST_SAVE_COMMENT = 'REQUEST_SAVE_COMMENT';
export const RECEIVE_SAVE_COMMENT = 'RECEIVE_SAVE_COMMENT';
export const REQUEST_ACTION_LOG = 'REQUEST_ACTION_LOG';
export const RECEIVE_ACTION_LOG = 'RECEIVE_ACTION_LOG';
export const REQUEST_COMMENTS = 'REQUEST_COMMENTS';
export const RECEIVE_COMMENTS = 'RECEIVE_COMMENTS';
export const REQUEST_DETAILS = 'REQUEST_DETAILS';
export const RECEIVE_DETAILS = 'RECEIVE_DETAILS';
export const RECEIVE_DETAILS_ERROR = 'RECEIVE_DETAILS_ERROR';
export const SUBMIT_CONFIG_SYMPTOM = 'SUBMIT_CONFIG_SYMPTOM';
export const CLEAR_STATE = 'CLEAR_STATE';
export const REQUEST_SET_FAULT_STATE = 'REQUEST_SET_FAULT_STATE'
export const RECEIVE_SET_FAULT_STATE = 'RECEIVE_SET_FAULT_STATE'
export const RECEIVE_VERIFICATION_OBSERVATIONS = 'RECEIVE_VERIFICATION_OBSERVATIONS'
export const SET_VERIFICATION_OBSERVATION = 'SET_VERIFICATION_OBSERVATION'
export const RECEIVE_CREATED_FCS = 'RECEIVE_CREATED_FCS'
export const SET_READ_ONLY = 'SET_READ_ONLY'
export const CHANGE_ACTION_FILTER = 'CHANGE_ACTION_FILTER'
export const RECEIVE_ERROR = 'RECEIVE_ERROR'
export const REQUEST_ASSIGN_USERS = 'REQUEST_ASSIGN_USERS'
export const RECEIVE_ASSIGN_USERS = 'RECEIVE_ASSIGN_USERS'
export const CLEAR_LOADING = 'CLEAR_LOADING'
export const REQUEST_DWP = 'REQUEST_DWP'
export const RECEIVE_DWP_ERROR = 'RECEIVE_DWP_ERROR'
export const RECEIVE_DWP = 'RECEIVE_DWP'

export const setAssetFault = (assetId, faultId) => {
    return {
        type: SET_ASSET_FAULT,
        faultId: faultId,
        assetId: assetId,
    }
}

export const fetchObservations = (assetId, faultId, external, symptomType) => dispatch => {
    dispatch(requestObservations());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchObservations(assetId, faultId, symptomType).then(
        function (response) {
            dispatch(receiveObservations(response));
        }
    );
}

const requestObservations = () => {
    return {
        type: REQUEST_OBSERVATIONS,
    }
}

const receiveObservations = (observations) => {
    return {
        type: RECEIVE_OBSERVATIONS,
        observations: observations,
    }
}

export const setObservation = (id, value) => {
    return {
        type: SET_OBSERVATION,
        id: id,
        value: value,
    }
}

export const fetchVerificationObservations = (assetId, faultId, external) => dispatch => {
    dispatch(requestObservations());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchObservations(assetId, faultId, [SYMPTOM_TYPES.OBSERVATIONS_TYPE, SYMPTOM_TYPES.REPORTED_SYMPTOM], [SYMPTOM_STATES.PRESENT]).then(
        function (response) {
            dispatch(receiveVerificationObservations(response));
        }
    );
}

const receiveVerificationObservations = (observations) => {
    return {
        type: RECEIVE_VERIFICATION_OBSERVATIONS,
        observations: observations,
    }
}

export const setVerificationObservation = (id, value) => {
    return {
        type: SET_VERIFICATION_OBSERVATION,
        id: id,
        value: value,
    }
}

export const submitObservations = (assetId, faultId, observations, external) => dispatch => {
    //before sending observations map newState property into state
    observations = observations.filter(o => o.newState != null).map(o => {
        o.state = o.newState || o.state
        delete o.newState
        return o
    })
    dispatch(requestSubmitObservations());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.submitObservations(assetId, faultId, observations).then(
        function (response) {
            dispatch(receiveSubmitObservations(response));
        }
    ).catch(err => {
        dispatch(receiveError(err));
        showNotification({
            translationPropertyKey: err.errorKey,
            severity: "critical",
        });
    })
}

const requestSubmitObservations = () => {
    return {
        type: REQUEST_SUBMIT_OBSERVATIONS,
    }
}

const receiveSubmitObservations = (fault) => {
    return {
        type: RECEIVE_SUBMIT_OBSERVATIONS,
        details: fault,
    }
}

export const fetchActions = (assetId, faultId, external) => dispatch => {
    dispatch(requestActions())
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchActions(assetId, faultId).then(
        function (actionResponse) {
            dispatch(receiveActions(actionResponse));
        }
    );
}

const requestActions = () => {
    return {
        type: REQUEST_ACTIONS,
    }
}

const receiveActions = (actions) => {
    return {
        type: RECEIVE_ACTIONS,
        actions: actions,
    }
}

export const fetchActionDetail = (assetId, actionId, actionType, external, faultId) => () => {
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchActionDetail(assetId, actionId, faultId, actionType);
}

export const submitTestResult = (assetId, faultId, testId, testValue, external, learningLoopTest, learningLoopTestResult) => dispatch => {
    dispatch(requestTestResult());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.submitTestResult(assetId, faultId, testId, testValue, learningLoopTest, learningLoopTestResult).then(
        function (response) {
            dispatch(receiveTestResult(response));
        }
    ).catch(err => {
        dispatch(receiveError(err));
        showNotification({
            translationPropertyKey: err.errorKey,
            severity: "critical",
        });
    })
}

const requestTestResult = () => {
    return {
        type: REQUEST_SUBMIT_TEST_RESULT,
    }
}

const receiveTestResult = (fault) => {
    return {
        type: RECEIVE_SUBMIT_TEST_RESULT,
        details: fault,
    }
}


export const submitCorrectiveActionResult = (assetId, faultId, actionId, actionValue, external) => dispatch => {
    dispatch(requestCorrectiveActionResult());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.submitCorrectiveActionResult(assetId, faultId, actionId, actionValue).then(
        function (response) {
            dispatch(receiveCorrectiveActionResult(response));
        }
    ).catch(err => {
        dispatch(receiveError(err));
        showNotification({
            translationPropertyKey: err.errorKey,
            severity: "critical",
        });
    })
}

const requestCorrectiveActionResult = () => {
    return {
        type: REQUEST_SUBMIT_CORRECTIVE_ACTION_RESULT,
    }
}

const receiveCorrectiveActionResult = (fault) => {
    return {
        type: RECEIVE_SUBMIT_CORRECTIVE_ACTION_RESULT,
        details: fault,
    }
}

export const saveComment = (assetId, faultId, comment, external) => dispatch => {
    dispatch(requestSaveComment());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.saveComment(assetId, faultId, comment).then(
        function () {
            dispatch(receiveSaveComment());
        }
    );
}

export const updateComment = (assetId, faultId, commentId, comment, external) => dispatch => {
    dispatch(requestSaveComment());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.updateComment(assetId, faultId, commentId, comment).then(
        function () {
            dispatch(receiveSaveComment());
        }
    ).catch((err) => {
        dispatch(receiveSaveComment());
        throw err
    });
}

const requestSaveComment = () => {
    return {
        type: REQUEST_SAVE_COMMENT,
    }
}

const receiveSaveComment = () => {
    return {
        type: RECEIVE_SAVE_COMMENT,
    }
}

export const fetchActionLog = (assetId, faultId, external) => dispatch => {
    dispatch(requestActionLog());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchActionLog(assetId, faultId, null, [LOG_ACTION_TYPES.VALUE_SET, LOG_ACTION_TYPES.REPORTED,
        LOG_ACTION_TYPES.STATE_CHANGED, LOG_ACTION_TYPES.LL_PACKET_SENT, LOG_ACTION_TYPES.ASSIGNEE_SET, LOG_ACTION_TYPES.LDI_IMPORT, LOG_ACTION_TYPES.VALUE_SET_LEARNING_LOOP], []).then(
        function (response) {
            dispatch(receiveActionLog(response));
        }
    );
}

const requestActionLog = () => {
    return {
        type: REQUEST_ACTION_LOG,
    }
}

const receiveActionLog = (actionLog) => {
    return {
        type: RECEIVE_ACTION_LOG,
        actionLog: actionLog,
    }
}

export const fetchCreatedFaults = (assetId, faultId, external) => dispatch => {
    dispatch(requestActionLog());
    const apiPoint = external ? Airtime : Faults
    const filterObj = {
        sort: [FAULT_SORT.NAME],
    }
    return apiPoint.fetchActionLog(assetId, null, faultId, [LOG_ACTION_TYPES.STATE_CHANGED], [LOG_OBJECT_TYPES.FAULT_CONDITION]).then(
        function (response) {
            const faultIds = response.filter(a => a.valueId === FAULT_STATES.NEW).map(a => a.objectId)
            if (faultIds.length > 0) {
                apiPoint.fetchAssetFaults(assetId, null, filterObj, faultIds).then(
                    function (res) {
                        dispatch(receiveCreatedFCs(res))
                    }
                )
            } else {
                dispatch(receiveCreatedFCs([]))
            }
        }
    );
}

const receiveCreatedFCs = (faults) => {
    return {
        type: RECEIVE_CREATED_FCS,
        faults: faults,
    }
}

export const fetchComments = (assetId, faultId, external) => dispatch => {
    dispatch(requestComments());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchComments(assetId, faultId).then(
        function (response) {
            dispatch(receiveComments(response));
        }
    );
}

const requestComments = () => {
    return {
        type: REQUEST_COMMENTS,
    }
}

const receiveComments = (comments) => {
    return {
        type: RECEIVE_COMMENTS,
        comments: comments,
    }
}


export const fetchDetails = (assetId, faultId, external) => dispatch => {
    dispatch(requestDetails());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchDetails(assetId, faultId)
        .then((response) => receiveDetailsBasedOnResponse(dispatch, response))
        .catch(err => {
            dispatch(receiveDetailsError(err));
        })
}

const requestDetails = () => {
    return {
        type: REQUEST_DETAILS,
    }
}

const receiveDetails = (details) => {
    return {
        type: RECEIVE_DETAILS,
        details: details,
    }
}

const receiveDetailsError = (err) => {
    return {
        type: RECEIVE_DETAILS_ERROR,
        error: err,
    }
}

const receiveDetailsBasedOnResponse = (dispatch, response) => {
    response.error ? dispatch(receiveDetailsError(response)) : dispatch(receiveDetails(response))
}

export const submitConfigSymptom = (assetId, faultId, id, value, external) => dispatch => {
    dispatch(submitNewStateOfConfigSymptom());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.submitConfigSymptom(assetId, faultId, id, value)
        .then((response) => receiveDetailsBasedOnResponse(dispatch, response))
        .catch(err => {
            dispatch(receiveDetailsError(err));
        })
}

const submitNewStateOfConfigSymptom = () => {
    return {
        type: SUBMIT_CONFIG_SYMPTOM,
    }
}

export const clearState = () => {
    return {
        type: CLEAR_STATE,
    }
}

export const setFaultState = (assetId, faultId, state, observations, comment, external) => dispatch => {
    dispatch(requestSetFaultState());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.setFaultState(assetId, faultId, state, observations, comment).then(
        function (response) {
            dispatch(receiveSetFaultState(response));
        }
    ).catch(err => {
        dispatch(receiveError(err));
        showNotification({
            translationPropertyKey: err.errorKey,
            severity: "critical",
        });
    })
}

const requestSetFaultState = () => {
    return {
        type: REQUEST_SET_FAULT_STATE,
    }
}

const receiveSetFaultState = (fault) => {
    return {
        type: RECEIVE_SET_FAULT_STATE,
        details: fault,
    }
}

const receiveError = (err) => {
    return {
        type: RECEIVE_ERROR,
        error: err,
    }
}

export const setReadOnly = (readOnly) => {
    return {
        type: SET_READ_ONLY,
        readOnly: readOnly,
    }
}


export const changeActionTypeFilter = (selectedActionTypes) => {
    return {
        type: CHANGE_ACTION_FILTER,
        selectedActionTypes: selectedActionTypes,
    }
}

export const assignUser = (assetId, faultId, userId, external) => dispatch => {
    dispatch(requestAssignUser())
    const apiPoint = external ? Airtime : Faults
    return apiPoint.assignUser(assetId, faultId, userId).then((response) => {
        dispatch(receiveAssignUser(response))
    }).catch((err) => {
        dispatch(clearLoading());
        throw err;
    })
}

/**
 * For the Airtime user this is not a new functionality.
 * The Airtime user will assign the fault to himself by going to troubleshooting by default. We can use existing endpoint.
 */
export const assignToSelf = (assetId, faultId, external) => dispatch => {
    dispatch(requestAssignUser())
    if (external) {
        return assignUser(assetId, faultId, null, true)
    }
    return Faults.assignToSelf(assetId, faultId).then((response) => {
        dispatch(receiveAssignUser(response))
    }).catch((err) => {
        dispatch(clearLoading());
        throw err;
    })
}

const requestAssignUser = () => {
    return {
        type: REQUEST_ASSIGN_USERS,
    }
}

const receiveAssignUser = (fault) => {
    return {
        type: RECEIVE_ASSIGN_USERS,
        details: fault,
    }
}

const clearLoading = () => {
    return {
        type: CLEAR_LOADING,
    }
}

export const fetchDwp = (assetId, faultId, external) => dispatch => {
    dispatch(requestDwp());
    const apiPoint = external ? Airtime : Faults
    return apiPoint.fetchDwp(assetId, faultId).then(
        function (response) {
            if (response.error) {
                dispatch(receiveDwpError(response));
            } else {
                dispatch(receiveDwp(response));
            }
        }
    ).catch(err => {
        dispatch(receiveDwpError(err));
    })
}

const requestDwp = () => {
    return {
        type: REQUEST_DWP,
    }
}

const receiveDwpError = (err) => {
    return {
        type: RECEIVE_DWP_ERROR,
        error: err,
    }
}

const receiveDwp = (dwp) => {
    return {
        type: RECEIVE_DWP,
        dwp: dwp,
    }
}

